import getUserOptions from './getUserOptions';

export default () => getUserOptions()?.TimeZone;
